import { useQuery } from '@tanstack/react-query';
import { getBrowseProducts } from '@/data/browseProducts';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Optimized hook for Browse page - fetches only essential product data
 * Uses 5-minute cache to reduce unnecessary refetches
 * Fetches favorites in parallel when user is logged in
 */
export function useBrowseProducts(showUnpublished = false) {
  const { user } = useAuth();
  
  return useQuery({
    queryKey: ['browse-products', showUnpublished, user?.id],
    queryFn: () => getBrowseProducts(showUnpublished, user?.id),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
